import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import DetailsMobile from './DetailsMobile';
import DetailsDesktop from './DetailsDesktop';

function Details({ app, config }) {
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    return isMobile ? (
        <DetailsMobile app={app} config={config} />
    ) : ( 
        <DetailsDesktop app={app} config={config} />
    );
}

Details.defaultProps = {
    app: null,
    config: {}
};

Details.propTypes = {
    app: PropTypes.object,
    config: PropTypes.object
};

export default Details;
